let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lvFwQ")).then(() => parcelRequire('gF7Z9'));